import React from 'react'
import {useState, useEffect} from 'react'
import DmtMarketplace from '../../components/Marketplace/DmtMarketplace';
import TapMarketplace from '../../components/Marketplace/TapMarketplace';
import UnatMarketplace from '../../components/Marketplace/UnatMarketplace';
import NameMarketplace from '../../components/Marketplace/NameMarketplace';
import ActivityMarketplace from '../../components/Marketplace/ActivityMarketplace';
import BitmapMarketplace from '../../components/Marketplace/BitmapMarketplace';
import Lrc20Marketplace from '../../components/Marketplace/Lrc20Marketplace';
import StampMarketplace from '../../components/Marketplace/StampMarketplace';
import Dust20Marketplace from '../../components/Marketplace/Dust20Marketplace';
import RuneMarketplace from '../../components/Marketplace/RuneMarketplace';
import Op20Marketplace from '../../components/Marketplace/Op20/Op20Marketplace';
import Op20Domain from '../../components/Marketplace/Op20/Op20Domain';
import { useLocation } from 'react-router-dom';
import Dropdown from '../../components/Dropdown/index';
import MezcalMarketplace from '../../components/Marketplace/Mezcal/MezcalMarketplace';

export default function Marketplace() {

  const currentPath = useLocation().pathname;
  const [tab, setTab] = useState(currentPath.includes('op20') ? 11 : currentPath.includes('mezcal') ? 13 : 11);
  const [type, setType]= useState(3);
  const [ticker, setTicker] = useState("");

  const dropdownTabs = ["OP20","OP_NAMES", "MEZCAL", "RUNES", "DUST-20", "TAP", "DMT", "UNAT", "LRC-20", "STAMP", "BITMAP", "NAMES"];

  const [activeDropDown, setActiveDropDown] = useState(currentPath.includes('op20') ? "OP20" : currentPath.includes('mezcal') ? "MEZCAL" : "OP20");

  const handleActivity = (type, ticker) => {
    setTab(3);
    setType(type);
    setTicker(ticker);
  }

  useEffect(() => {
    switch (activeDropDown) {
      case "OP20":
        setTab(11);
        break;
      case "OP_NAMES":
        setTab(12);
        break;
      case "MEZCAL":
        setTab(13);
        break;
      case "RUNES":
        setTab(10);
        break;
      case "DUST-20":
        setTab(8);
        break;
      case "TAP":
        setTab(0);
        break;
      case "DMT":
        setTab(1);
        break;
      case "UNAT":
        setTab(2);
        break;
      case "LRC-20":
        setTab(6);
        break;
      case "BITMAPS":
        setTab(5);
        break;
      case "STAMP":
        setTab(7);
        break;
      case "NAMES":
        setTab(4);
        break;
    }
  }, [activeDropDown])

  return (
    <div className="text-white mt-[65px] w-full md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      <div className="sm:flex hidden sm:flex-row flex-wrap sm:gap-2 gap-1 w-full mt-5 mb-2">
        <div className={`sm:text-[18px] text-[14px] ${tab == 11 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(11)}>OP20</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 12 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(12)}>OP_NAMES</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 13 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(13)}>MEZCAL</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 10 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(10)}>RUNES</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 8 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(8)}>DUST-20</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 0 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(0)}>TAP</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 1 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(1)}>DMT</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 2 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(2)}>UNAT</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 6 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(6)}>LRC-20</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 7 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(7)}>STAMP</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 5 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(5)}>BITMAP</div>
        <div className={`sm:text-[18px] text-[14px] ${tab == 4 ? 'text-primary border-[1px] border-primary border-solid' : ''} hover:text-primary sm:px-4 px-2 py-1 rounded-md cursor-pointer`} onClick={() => setTab(4)}>NAMES</div>
        <div className={`sm:text-[18px] text-[14px] px-2 py-1 bg-primary hover:bg-primary-hover cursor-pointer text-white rounded-md`} onClick={() => {setTab(3); setTicker(""); setType(3)}}>ACTIVITY</div>
      </div>
      <div className="sm:hidden flex flex-row gap-3 w-full items-center">
        <Dropdown tabs = {dropdownTabs} setActiveDropDown = {setActiveDropDown} activeDropDown = {activeDropDown}/>
        <div className={`text-[18px] w-full text-center px-2 py-2 bg-primary hover:bg-primary-hover cursor-pointer text-white rounded-md`} onClick={() => setTab(3)}>Activity</div>
      </div>
      {
        tab == 11 ? <Op20Marketplace/> : <></>
      }
      {
        tab == 12 ? <Op20Domain/> : <></>
      }
      {
        tab == 13 ? <MezcalMarketplace/> : <></>
      }
      {
        tab == 10 ? <RuneMarketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 0 ? <TapMarketplace handleActivity = { handleActivity } />: <></>
      }
      {
        tab == 1 ? <DmtMarketplace handleActivity = { handleActivity }  /> : <></>
      }
      {
        tab == 2 ? <UnatMarketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 4 ? <NameMarketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 3 ? <ActivityMarketplace type={type} ticker={ticker}/> : <></>
      }
      {
        tab == 5 ? <BitmapMarketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 6 ? <Lrc20Marketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 7 ? <StampMarketplace handleActivity = { handleActivity } /> : <></>
      }
      {
        tab == 8 ? <Dust20Marketplace handleActivity = { handleActivity } /> : <></>
      }
    </div>
  )
}
